module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-75.c91c0c2a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-75.png
// module id = 3341
// module chunks = 11